<template>
<div>
    <div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center mb-4">
                <h5 class="card-title flex-grow-1 mb-0">Documents</h5>
                <div class="flex-shrink-0">
                    <button @click="popupModalShow = true" type="button" class="btn btn-primary"><i class="ri-upload-2-fill me-1 align-bottom"></i>
                        Upload File</button>
                </div>
            </div>
            <CommonSpinner v-if="isLoading" />
            <div v-else class="row g-4">
                <div class="col-lg-12">
                    <div class="table-responsive">
                        <table class="table table-borderless align-middle mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th scope="col">Action</th>
                                    <th scope="col">File Name</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Size</th>
                                    <th scope="col">Upload Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, docIndex) in pageData.data" :key="docIndex">
                                    <td>
                                        <div class="dropdown dropstart no-arrow">
                                            <button class="dropdown-toggle btn btn-light btn-icon" type="button"
                                                role="button"  data-bs-toggle="dropdown" aria-expanded="false">
                                                <i class="ri-equalizer-fill"></i>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li>
                                                    <button @click.prevent="showPdfModal(data.path)" class="dropdown-item" type="button"><i
                                                            class="ri-eye-fill me-2 align-middle text-muted"></i>View</button>
                                                </li>
                                                <li class="dropdown-divider"></li>
                                                <li>
                                                    <button @click.prevent="deleteItem(data.id)" class="dropdown-item" type="button"><i
                                                            class="ri-delete-bin-5-line me-2 align-middle text-muted"></i>Delete</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div class="avatar-sm">
                                                <div class="avatar-title bg-soft-danger text-danger rounded fs-20">
                                                    <i class="ri-file-pdf-fill"></i>
                                                </div>
                                            </div>
                                            <div class="ms-3 flex-grow-1">
                                                <h6 class="fs-15 mb-0">
                                                    <span> {{ data.name }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                    </td>
                                    <td> {{ data.category_title }} </td>
                                    <td><span class="text-uppercase">{{ data.extension }}</span> - {{ data.size }}</td>
                                    <td>{{ $filters.date(data.created_at) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p v-if="!pageData.data.length" class="py-2 mt-3 text-center">No documents added</p>
                </div>
            </div>
        </div>
    </div>            
                       
    <b-modal v-model="popupModalShow" hide-footer centered
        title="Upload Document"
        title-class="fs-6" body-class="loading-viewport" @hide="initializeAll()">
        <document-form v-if="popupModalShow" @closeMe="initializeAll()"
         @addedItem="addItem($event)" />
    </b-modal>
</div>
</template>


<script>
import DocumentForm from '@/components/forms/DocumentForm.vue';
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
    components:{
        DocumentForm,
    },
    mixins:[
        commonPaginationMixin
    ],
    data() {
        return {
            isLoading: false,
            popupModalShow: false,
        }
    },
    methods: {
        addItem(item){
            this.pageData.data.unshift(item);
        },
        fetchItems() {
            this.isLoading = true
            this.$http.get('/documents').then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.pageData = response.data.data
                    this.initializeAll();
                }
            })
        },
        deleteItem(itemId) {
            this.confirmDelete({
                text: "You are about to delete this document permanently",
            }).then((result) => {
                if (result.value) {
                this.$store.dispatch("changeLoaderValue",true)
                this.$http.delete(`/documents/${itemId}/delete`)
                .then(response => {
                    this.$store.dispatch("changeLoaderValue",false)
                    if(response.data.success){
                        const ItemIndex = this.pageData.data.findIndex((item) => item.id == itemId)
                        this.pageData.data.splice(ItemIndex, 1);
                    }
                })
                }
            });
        },
        showPdfModal(item) {
            let filePath = this.absoluteUrl(item);
            this.$store.commit('TOGGLE_PDF_MODAL_FRAME', { visible: true, filePath: filePath})
        },
        initializeAll(){
            this.popupModalShow = false;
        },
    },
    created(){
        this.fetchItems()
    },
}
</script>

<style></style>